import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  styled,
} from "@mui/material";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: "16px",
  "& .MuiFormControlLabel-root": {
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& .MuiTypography-root": {
    fontSize: "14px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
}));

interface QuestionRadioProps {
  questionNumber: number;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  onFocus: (questionNumber: number) => void;
}

function QuestionRadio({ questionNumber, options, value, onChange, onFocus }: QuestionRadioProps) {
  return (
    <StyledFormControl fullWidth onFocus={() => onFocus(questionNumber)}>
      <RadioGroup
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        aria-labelledby={`question-${questionNumber}-label`}
      >
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option}
            control={<Radio />}
            label={option}
          />
        ))}
      </RadioGroup>
    </StyledFormControl>
  );
}

export default QuestionRadio;
